oyc.FormCache = {
  dependencies: ['DocCookies'],
  selectors: {
    formElements: 'input[name]:not([name*="referrer"],[name*="trustedProperties"]),select',
  },
  // property to be set to true as soon as all is initialized
  // only then values get stored
  enabled: false,

  form: null,
  formData: [],
  separator: '|',
  warn: function () {
    console.log('formCache is not initialized.');
  },
  disabled: function () {
    console.log('formCache is not activated yet.');
  },

  storageKey: 'formData',

  init: function (formId) {
    const f = (typeof formId === 'undefined' || formId === null || $.trim(formId) === '')
      ? $('form:not(.hidden-fields, .oyc-form-cache-ignore)').first()
      : $('#' + formId);
    if (0 < f.length) {
      this.form = f;
      if (this.formHasValues() === false) {
        this.storageKey += location.pathname.replace(/(\/|\.html)/g, '-').replace(/-$/, '');
        this.fetch()
      } else {
        console.log('leave fields empty, due to fields having values ');
      }
    }
    return this; // make it chainable
  },

  formHasValues: function () {
    let formElements = this.form.find(this.selectors.formElements);
    for (let i = 0; i < formElements.length; i++) {
      // multiple selects return an array, default values are provided as comma separated list
      const fieldVal = [].concat($(formElements[i]).val()).join(','),
        defaultVal = formElements[i].dataset['defaultValue'] || false;
      if (
        (fieldVal !== '' && defaultVal !== false && fieldVal !== defaultVal) &&
        ((formElements[i].type !== 'radio' && formElements[i].type !== 'checkbox') || 'checked' in formElements[i] && formElements[i].checked)
      ) {
        return true;
      }
    }
    return false;
  },

  /**
   * Stores the form data in the cookies.
   * @todo optimize storing checkbox data - prevent an entry for each checkbox, consolidate them
   */
  save: function () {
    if (this.saveEnabled === false) return this.disabled();
    if (this.form === null) return this.warn();

    let inputs = this.form.find(this.selectors.formElements);
    let radios = inputs.filter('[type="radio"]')
    if (radios.length) {
      let checkedRadios = radios.filter(':checked');
      if (0 < checkedRadios.length) {
        radios = checkedRadios;
      }
      for (let i = 0; i < radios.length; i++) {
        let item = radios[i];
        let value = item.name + ':' + (item.checked ? item.value : '');
        if (this.formData.indexOf(value) === -1) {
          this.formData.push(value)
        }
      }
    }

    inputs.not('[type="radio"]')
      .each(function (i, el) {
        let f = '';
        if (el.id === 'location-filter' && el.parentElement.classList.contains('ui')) {
          const ui = $(el).closest('.ui.dropdown');
          let value = ui.dropdown('get value');
          if (value) {
            value = JSON.stringify({
              coords: value,
              label: ui.dropdown('get text'),
            });
          }
          f = el.name + ':' + value;
        } else {
          f = el.name + ':' + this.getFieldValue($(el));
        }
        this.formData.push(f);
      }.bind(this));
    if (typeof Storage === 'undefined') {
      oyc.DocCookies.setItem(this.storageKey, this.formData.join(this.separator), 31536e3); // 1 year expiration (persistent)
    } else {
      localStorage[this.storageKey] = this.formData.join(this.separator);
    }
    console.log('Cached form data:', this.formData);
    return false;
  },

  /**
   * Gets the previously stored value of the specified form field.
   */
  getFieldValue: function (elem) {
    if (this.form === null) return this.warn();
    if (elem.is('input:radio')) return console.warn('radio buttons need to be handled as a group due to having same name ');

    if (elem.is('input:text') || elem.is('input:hidden') || elem.is('input:image') ||
      elem.is('input:file') || elem.is('textarea')) {
      return elem.val() || '';
    } else if (elem.is('input:checkbox')) {
      return elem.prop('checked') ? elem.val() : '';
    } else if (elem.is('select')) {
      return elem.prop('selectedIndex') || '';
    } else return null;
  },

  /**
   * Fills out the form elements from the data previously stored in the cookies.
   */
  fetch: function () {
    let fd;
    if (this.form === null) return this.warn();
    if (typeof Storage !== 'undefined') {
      if (localStorage.getItem(this.storageKey) === null) {
        localStorage.setItem(this.storageKey, '');
      }
      fd = localStorage.getItem(this.storageKey);
    } else {
      if (!oyc.DocCookies.hasItem(this.storageKey)) return;
      fd = oyc.DocCookies.getItem(this.storageKey);
    }
    fd = this.formData.length < 1 ? fd.split(this.separator) : this.formData;
    let dispatchReload = false, elem = null;
    $.each(fd, function (i, item) {
      if (typeof item !== 'string' || item === '') {
        return;
      }
      let [fieldName, value] = item.match(/([^:]+):(.*)/).slice(1);
      try {
        value = JSON.parse(value);
      } catch (e) {
      }
      if (typeof value === 'object') {
        elem = this.form.get(0).querySelector('[name*="' + fieldName + '"]');
      } else {
        elem = this.form.get(0).querySelector('[name*="' + fieldName + '"][value="' + value.toString().replace(/(\[[^\]]*])/g, '') + '\\$1\\') || this.form.get(0).querySelector('[name*="' + fieldName + '"]');
      }
      if (elem && value) {
        this.setFieldValue($(elem), value);
        dispatchReload = true;
      } else if (value) {
        const methodName = 'set' + fieldName.replace(/.*\[|]/g, '').split('.').map(value =>
          typeof value === 'string'
            ? value.charAt(0).toUpperCase() + value.slice(1)
            : value
        ).join('') + 'Value';
        if (methodName in this) {
          this[methodName](elem, value);
          dispatchReload = true;
        }
      }
    }.bind(this));
    if (dispatchReload) {
      this.form.get(0).dataset.formCacheFoundAndSet = "1";
    }
    return this;
  },

  /**
   * Sets the value of the specified form field from previously stored data.
   *
   * @param {jQuery} elem
   * @param {string|int|object} value
   * @returns {oyc.FormCache|void}
   */
  setFieldValue: function (elem, value) {
    if (this.form === null) return this.warn();
    if (elem.attr('id') === 'location-filter' && typeof value === 'object') {
      this.setUiDropdownValue(elem, value);
    } else if (elem.is('input:text') || elem.is('input:hidden') || elem.is('input:image') ||
      elem.is('input:file') || elem.is('textarea')) {
      elem.val(value);
    } else if ((elem.is('input:checkbox') || elem.is('input:radio')) && value !== '' && parseInt(value) !== 0) {
      elem.prop('checked', value);
    } else if (elem.is('select')) {
      elem.prop('selectedIndex', value);
    }
    return this;
  },

  setUiDropdownValue: function (elem, value) {
    if ('coords' in value) {
      if (elem.hasClass('ui', 'dropdown')) {
        elem.append('<option value="' + value.coords + '" selected>' + value.label + '</option>');
      } else {
        const ui = elem.closest('.ui.dropdown');
        ui.dropdown('set value', value.coords);
        ui.dropdown('set text', value.label);
      }
    }
  },

  /**
   * Clears the cache and removes the previously stored form data from cookies.
   */
  clear: function () {
    this.formData = [];
    oyc.DocCookies.removeItem(this.storageKey);
    return this;
  },

  /**
   * Clears all the form fields.
   * This is different from form.reset() which only re-sets the fields
   * to their initial values.
   */
  clearForm: function () {
    this.form
      .find(this.selectors.formElements)
      .each(function (i, el) {
        var jEl = $(el);
        if (jEl.is('input:text') || jEl.is('input:password') || jEl.is('input:hidden') ||
          jEl.is('input:image') || jEl.is('input:file') || jEl.is('textarea')) {
          jEl.val('');
        } else if (jEl.is('input:checkbox') || jEl.is('input:radio')) {
          jEl.prop('checked', false);
        } else if (jEl.is('select')) {
          jEl.prop('selectedIndex', -1);
        }
      }.bind(this));
    return this;
  },
  setLocationUidValue: function (elem, value) {
    $(document).on('map:initialized', () => {
      console.log('map:initialized - now opening InfoWindow of location from FormCache', 'uid: ' + value);
      if (value) {
        const dataObject = oyc.Map.Marker.objects.find(obj => obj.location.uid === value);
        console.log('dataObject:', dataObject);
        if (location) {
          oyc.Map.InfoWindow.open(dataObject);
          oyc.Map.InfoWindow.filterClick({currentTarget: $('<button type="button" data-filter-value="' + dataObject.location.uid + '" data-filter-label="' + dataObject.location.name + '">').get(0)});
        }
      }
    });
  }
}
